import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const CANCEL_INVOICE_CLIENT_RESET   = 'CANCEL_INVOICE_CLIENT_RESET';
export const CANCEL_INVOICE_CLIENT_LOADING = 'CANCEL_INVOICE_CLIENT_LOADING';
export const CANCEL_INVOICE_CLIENT_SUCCESS = 'CANCEL_INVOICE_CLIENT_SUCCESS';
export const CANCEL_INVOICE_CLIENT_REJECT  = 'CANCEL_INVOICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const cancelInvoiceClientReset   = () => ({ type: CANCEL_INVOICE_CLIENT_RESET });
export const cancelInvoiceClientLoading = () => ({ type: CANCEL_INVOICE_CLIENT_LOADING });
export const cancelInvoiceClientSuccess = (payload) => ({ type: CANCEL_INVOICE_CLIENT_SUCCESS, payload });
export const cancelInvoiceClientReject  = (payload) => ({ type: CANCEL_INVOICE_CLIENT_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const cancelInvoiceClientRequest = async (body = {}, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data: body,
    }, getState);
    return request(`/Invoices/web/UpdateInvoicesCancel`, options);
};
